





































import {Component, Prop, Vue} from 'vue-property-decorator'
import * as Helper from '@/helpers'
import Pdf from 'vue-pdf'

@Component({
  components: {Pdf},
})
export default class PhotoSlider extends Vue {
  @Prop({type: Array, required: true}) photoList!: string[]
  @Prop({type: String, required: true}) iconUrl!: string
  @Prop({type: String, required: true}) sectionName!: string
  @Prop({type: Boolean, default: false}) isOccurrence!: boolean
  @Prop({type: String, default: '0rem'}) zoomImgTopPosition!: string

  Helper = Helper

  imageIndex = 0
  hasNext = true
  hasPrevious = false
  showZoom = false

  img: HTMLImageElement | null = null
  result: HTMLElement | null = null
  lens: HTMLElement | null = null
  imgContainer: HTMLElement | null = null

  cx = 0
  cy = 0

  resultImg = {
    backgroundImage: '',
    backgroundPosition: '',
    backgroundSize: '',
    left: '',
    top: this.zoomImgTopPosition,
  }

  lensDiv = {
    top: '',
    left: '',
  }

  initializeZoomImg() {
    this.img = document.getElementById(this.imgId) as HTMLImageElement
    this.result = document.getElementById(this.resultId)
    this.lens = document.getElementById(this.lensId)
    this.imgContainer = document.getElementById(this.imgContainerId)

    if (!this.result || !this.lens || !this.img || !this.imgContainer) return

    // result.offsetWidth or height is not available because it's hidden
    this.cx = 450 / this.lens.offsetWidth
    this.cy = 450 / this.lens.offsetHeight

    this.resultImg.backgroundSize = (this.img.width * this.cx) + 'px ' + (this.img.height * this.cy) + 'px'
    this.resultImg.left = '23rem'
  }

  moveLens(e: MouseEvent) {
    let pos
    let x
    let y

    e.preventDefault()
    pos = this.getCursorPosition(e)

    if (!pos || !this.lens || !this.img || !this.result || !this.imgContainer) return

    x = pos.x - (this.lens.offsetWidth / 2)
    y = pos.y - (this.lens.offsetHeight / 2)

    if (x > this.img.width - this.lens.offsetWidth) {x = this.img.width - this.lens.offsetWidth}
    if (x < 0) {x = 0}
    if (y > this.img.height - this.lens.offsetHeight) {y = this.img.height - this.lens.offsetHeight}
    if (y < 0) {y = 0}

    // since the container has flex and it's aligned to the middle of the div
    // and the lens has position absolute and it's not affected by it
    // we need to get how much the image has moved to the right and to the bottom and apply
    const container = this.imgContainer.getBoundingClientRect()
    this.lensDiv.left = x + ((container.width - this.img.width) / 2) + 'px'
    this.lensDiv.top = y + ((container.height - this.img.height) / 2) + 'px'

    this.resultImg.backgroundImage = 'url(\'' + this.photoList[this.imageIndex] + '\')'
    this.resultImg.backgroundPosition = '-' + (x * this.cx) + 'px -' + (y * this.cy) + 'px'
  }

  getCursorPosition(e: MouseEvent) {
    let a
    let x = 0
    let y = 0

    e = e || window.event

    if (!this.img) return

    a = this.img.getBoundingClientRect()
    x = e.pageX - a.left
    y = e.pageY - a.top
    x = x - window.pageXOffset
    y = y - window.pageYOffset

    return {x, y}
  }

  get lensStyle() {
    return this.showZoom ? {
      backgroundColor: 'grey',
      opacity: 0.5,
      border: '2px solid black',
    } : {
      backgroundColor: 'transparent',
      border: 'none',
      opacity: 1,
    }
  }

  openZoom() {
    if (!Helper.isPdfFile(this.photoList[this.imageIndex])) {
      this.showZoom = true
    }
  }

  closeZoom() {
    this.showZoom = false
  }

  get lensId() {
    return this.sectionName.replace(' ', '') + '-lens'
  }

  get imgId() {
    return this.sectionName.replace(' ', '') + '-img'
  }

  get resultId() {
    return this.sectionName.replace(' ', '') + '-result'
  }

  get imgContainerId() {
    return this.sectionName.replace(' ', '') + '-container'
  }

  async mounted() {
    this.hasNext = this.photoList.length > 1
  }

  next() {
    const nextImage = this.photoList[this.imageIndex + 1]

    if (nextImage) {
      this.updateImage(nextImage)
    }
  }

  prev() {
    const prevImage = this.photoList[this.imageIndex - 1]

    if (prevImage) {
      this.updateImage(prevImage)
    }
  }

  updateImage(image: string) {
    this.imageIndex = this.photoList.indexOf(image)
    this.hasNext = this.imageIndex + 1 < this.photoList.length
    this.hasPrevious = this.imageIndex > 0
  }

  get icon() {
    return require(`@/assets/img/icon/${this.iconUrl}`)
  }

  openImageDisplay() {
    const src = this.photoList[this.imageIndex]
    if (src) {
      this.$modal.open('imageDisplay', {src, showDownload: true})
    }
  }
}
